import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED } from 'api/actions'
import PanelExpanded from 'api/PanelExpanded'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import PoziDrawerTabSearch from 'drawer/tabs/search/Search'
import IsSmallScreen, { SMALL_SCREEN_PIXELS } from 'utils/IsSmallScreen'

import SearchOptions from './SearchOptions'

const styles = theme => ({
  root: {},
  rootDetails: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: 10,
    paddingLeft: 10,
    paddingTop: 0,
    paddingBottom: 0,
    rowGap: 10
  }
})

class SearchPanelFind extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeStep: 0
    }
    const { title } = props
    this.pure = {}
    this.pure.title = title
    this.pure.headerIcon = <SearchIcon />
  }

  loadLegacy () {
    PoziDrawerTabSearch().init()
    if (!IsSmallScreen(SMALL_SCREEN_PIXELS)) {
      window.setTimeout(function () {
        const el = document.getElementById('q')
        if (!isNil(el)) {
          el.focus()
        }
      }, 500)
    }
  }

  componentDidMount () {
    const { expanded } = this.props
    if (expanded) {
      this.loadLegacy()
    }
  }

  componentDidUpdate (prevProps) {
    const { expanded } = this.props
    if (expanded !== prevProps.expanded && expanded) {
      this.loadLegacy()
    }
  }

  render () {
    const { classes, enabled, expanded, toggleExpansionPanel } = this.props

    if (!enabled) {
      return null
    }

    if (expanded) {
      // The following section of code should not be in the render function
      // Hack to make this run without React givng a warning about a component
      // being updated from inside the function body of a different component
      window.setTimeout(function () {
        PanelExpanded(LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED)
      }, 0)
    }

    return (
      <div className={classes.root}>
        <AccordionWrapper
          expanded={expanded}
          onChange={toggleExpansionPanel}
          headerIcon={this.pure.headerIcon}
          title={this.pure.title}
          bExcludeExpandIcon={false}
        >
          <div className={classes.rootDetails}>
            <SearchOptions />
          </div>
        </AccordionWrapper>
      </div>
    )
  }
}

SearchPanelFind.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpansionPanel: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const enabled = get(state, 'config.layout.drawer.tabs.search.panels.find.visible', true) // See templates.json
  const title = get(state, 'config.layout.drawer.tabs.search.panels.find.title', 'Find') // See templates.json
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED, false)
  return {
    enabled,
    title,
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanelFind)
  )
)
